<template>
    <div>
        <b-modal id="modal-bulk-due-date-update" no-close-on-esc centered no-close-on-backdrop hide-footer
            :body-class="'pt-3'">
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('bulkDueDateUpdate.title') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="text-left">
                <label for="modal-add-record-date-datepicker" class="state">{{ $t('bulkDueDateUpdate.dueDateLabel') }}</label>
                <date-picker v-model="due_date" :formatter="momentFormat" :range-separator="' - '"
                    @clear="due_date = ''" :placeholder="$t('bulkDueDateUpdate.selectDueDate')" class="date-picker-custom"
                    :teleport="'body'"></date-picker>
                <p v-if="error && error.due_date" class="field-error">
                    {{ error.due_date[0] }}
                </p>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-3">
                <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('bulkDueDateUpdate.cancel') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary" @click="bulkUpdateTasks">{{ $t('bulkDueDateUpdate.save') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as moment from "moment-timezone";
export default {
    name: "BulkDueDateUpdate",
    components: {
        DatePicker,
    },
    data() {
        return {
            error: {},
            due_date: null,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
        }
    },
    props: ["title", "taskIds"],
    computed:{
        ...mapGetters(["allTeamMembers"]),
    },
    methods: {
        ...mapActions(["updateBulkTasks", "setNotification", "setLoader", "getAllTeamMembers"]),
        resetPopup() {
            this.error = {}
            this.due_date = null
            this.$bvModal.hide('modal-bulk-due-date-update')
            this.$emit('close')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (value === null) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async bulkUpdateTasks() {
            try {
                const nullKeys = this.checkNullValues({
                    due_date: this.due_date
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.updateBulkTasks({
                        "task_ids": this.taskIds,
                        "due_date": moment(this.due_date).format('YYYY-MM-DD')
                    })
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('bulkDueDateUpdate.tasksUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("updateDocs")
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('bulkDueDateUpdate.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.error = error;
                }
            }
        }
    },
}
</script>